import { render, staticRenderFns } from "./TradeCharts.vue?vue&type=template&id=142ea1b6&scoped=true&"
import script from "./TradeCharts.vue?vue&type=script&lang=ts&"
export * from "./TradeCharts.vue?vue&type=script&lang=ts&"
import style0 from "./TradeCharts.vue?vue&type=style&index=0&id=142ea1b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142ea1b6",
  null
  
)

export default component.exports